module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#instagram",
      toString: function () {
        return this.url;
      }
    }